package music.jammers.client.shared.network.di

import io.ktor.client.HttpClient
import io.ktor.client.plugins.logging.Logger
import music.jammers.client.shared.network.domain.model.ApiConfig
import music.limasoul.client.shared.network.ErrorMapper
import music.limasoul.client.shared.network.HttpClientFactory
import music.limasoul.client.shared.network.JammersErrorMapper
import org.koin.dsl.module

val networkSharedModule = module {

    single<HttpClient> {
        val apiConfig = get<ApiConfig>()
        HttpClientFactory.create(
            baseUrl = apiConfig.getBaseUrl(),
            enableLogging = true,
            log = object : Logger {
                override fun log(message: String) {
                    println(message)
                }
            },
            errorMapper = get(),
            tokenRepository = get()
        )
    }

    single<ErrorMapper> {
        JammersErrorMapper()
    }
}